import { createResourceModule } from '../../../lib/resource/module.js';
import { tenantAdminDetail } from './schemas.js';

/**
 * The Tenant Admins module's API layer.
 *
 * The standard CRUD surface comes from the shared resource factory; the
 * tenant-scoped `tenantId` query on delete is the only override, because a
 * platform operator can manage administrators across tenants and the route
 * needs to know which tenant the administrator belongs to.
 */
export const tenantAdmins = createResourceModule({
  resource: 'tenantAdmins',
  basePath: '/v1/tenant-admins',
  detail: tenantAdminDetail,
});

export const tenantAdminEndpoints = {
  ...tenantAdmins.endpoints,
  delete: (userId: string, tenantId: string) =>
    `${tenantAdmins.endpoints.delete(userId)}?tenantId=${encodeURIComponent(tenantId)}`,
} as const;
